<style lang="scss">
.nav-pills .nav-item .nav-link.active {
  background-color: #007bff;
  border-radius: 0.25rem !important;
}
.nav-pills .nav-item .nav-link {
  border: 0px solid #007bff;
}
.nav.nav-pills {
  margin-bottom: 10px;
}
</style>
<template>
  <div class="card">
    <div class="card-header">
      <h4>Bildeinstellungen</h4>
    </div>
    <div class="card-body">
      <ul class="nav nav-pills" id="myTab" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" data-toggle="tab" href="#www" role="tab"
            >WWW</a
          >
        </li>
        <li class="nav-item">
          <a class="nav-link" data-toggle="tab" href="#mod-panel" role="tab"
            >Mod-Panel</a
          >
        </li>
        <li class="nav-item">
          <a class="nav-link" data-toggle="tab" href="#admin-panel" role="tab"
            >Admin-Panel</a
          >
        </li>
      </ul>
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade show active" id="www" role="tabpanel">
          <div class="form-group row">
            <col-label>Mitgliedersuche</col-label>
            <div class="col-8">
              <input
                type="number"
                class="form-control"
                v-model="data.wwwMemberSearchImages"
              />
            </div>
          </div>
          <div class="form-group row">
            <col-label>Interessante Mitglieder</col-label>
            <div class="col-8">
              <input
                type="number"
                class="form-control"
                v-model="data.wwwProposalImages"
              />
            </div>
          </div>
          <div class="form-group row">
            <col-label>Großes Profilbild</col-label>
            <div class="col-8">
              <input
                type="number"
                class="form-control"
                v-model="data.wwwPrimaryImages"
              />
            </div>
          </div>
          <div class="form-group row">
            <col-label>kleinere untere Profilbilder</col-label>
            <div class="col-8">
              <input
                type="number"
                class="form-control"
                v-model="data.wwwProfileImages"
              />
            </div>
          </div>
          <div class="form-group row">
            <col-label>Chat Bilder</col-label>
            <div class="col-8">
              <input
                type="number"
                class="form-control"
                v-model="data.wwwChatImages"
              />
            </div>
          </div>
          <hr />
          <div class="form-group row">
            <col-label>Bild Qualität</col-label>
            <div class="col-8">
              <div class="input-group">
                <input
                  type="number"
                  min="0"
                  max="100"
                  class="form-control"
                  placeholder="Basis Prozent"
                  v-model="data.wwwImageQuality"
                />
                <div class="input-group-append">
                  <span class="input-group-text">%</span>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <col-label>Bild Format</col-label>
            <div class="col-8">
              <select class="form-control" v-model="data.wwwImageFormat">
                <option value="jpg">JPG</option>
                <option value="png">PNG</option>
                <option value="webp">WebP</option>
              </select>
            </div>
          </div>
        </div>
        <div class="tab-pane fade show" id="mod-panel" role="tabpanel">
          <div class="form-group row">
            <col-label>Großes Profilbild</col-label>
            <div class="col-8">
              <input
                type="number"
                class="form-control"
                v-model="data.modPrimaryImages"
              />
            </div>
          </div>
          <div class="form-group row">
            <col-label>kleinere untere Profilbilder</col-label>
            <div class="col-8">
              <input
                type="number"
                class="form-control"
                v-model="data.modProfileImages"
              />
            </div>
          </div>
          <div class="form-group row">
            <col-label>Profilbilder im Modal</col-label>
            <div class="col-8">
              <input
                type="number"
                class="form-control"
                v-model="data.modModalImages"
              />
            </div>
          </div>
          <div class="form-group row">
            <col-label>Chat Bilder</col-label>
            <div class="col-8">
              <input
                type="number"
                class="form-control"
                v-model="data.modChatImages"
              />
            </div>
          </div>
          <hr />
          <div class="form-group row">
            <col-label>Bild Qualität</col-label>
            <div class="col-8">
              <div class="input-group">
                <input
                  type="number"
                  min="0"
                  max="100"
                  class="form-control"
                  placeholder="Basis Prozent"
                  v-model="data.modImageQuality"
                />
                <div class="input-group-append">
                  <span class="input-group-text">%</span>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <col-label>Bild Format</col-label>
            <div class="col-8">
              <select class="form-control" v-model="data.modImageFormat">
                <option value="jpg">JPG</option>
                <option value="png">PNG</option>
                <option value="webp">WebP</option>
              </select>
            </div>
          </div>
        </div>
        <div class="tab-pane fade show" id="admin-panel" role="tabpanel">
          <div class="form-group row">
            <col-label>Chat Bilder</col-label>
            <div class="col-8">
              <input
                type="number"
                class="form-control"
                v-model="data.adminChatImages"
              />
            </div>
          </div>
          <hr />
          <div class="form-group row">
            <col-label>Bild Qualität</col-label>
            <div class="col-8">
              <div class="input-group">
                <input
                  type="number"
                  min="0"
                  max="100"
                  class="form-control"
                  placeholder="Basis Prozent"
                  v-model="data.adminImageQuality"
                />
                <div class="input-group-append">
                  <span class="input-group-text">%</span>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <col-label>Bild Format</col-label>
            <div class="col-8">
              <select class="form-control" v-model="data.adminImageFormat">
                <option value="jpg">JPG</option>
                <option value="png">PNG</option>
                <option value="webp">WebP</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="form-group">
          <button @click="persist()" class="btn btn-primary">Speichern</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    this.$store.dispatch("setting/all").then(() => {
      const settings = this.$store.getters["setting/all"];
      Object.keys(settings).forEach(key => {
        this.data[key] = settings[key];
      });
    });
  },
  methods: {
    persist() {
      const data = Object.assign({}, this.data);
      this.$store.dispatch("setting/update", data).then(() => {
        this.$notify({
          title: "Bildeinstellungen gespeichert",
          type: "success"
        });
      });
    }
  },
  data() {
    return {
      data: {
        wwwMemberSearchImages: 200,
        wwwProposalImages: 120,
        wwwPrimaryImages: 300,
        wwwProfileImages: 150,
        wwwChatImages: 500,
        wwwImageQuality: 90,
        modPrimaryImages: 250,
        modProfileImages: 75,
        modModalImages: 500,
        modChatImages: 500,
        modImageQuality: 80,
        adminChatImages: 500,
        adminImageQuality: 80,
        wwwImageFormat: "webp",
        modImageFormat: "webp",
        adminImageFormat: "web"
      }
    };
  }
};
</script>
